// REPLACE your Journal.jsx with this version:

import React from 'react';
import PrintSafeImage from '../PrintSafeImage';
import { sanitizeRichText } from '../../utils/pastTripsAlbumTemplate';

export default function Journal({ items = [], blocks = {}, meta, isPrinting }) {
  const first = items?.[0];
  const showText = blocks?.text ?? true; // default show text block

  // Apply position data if it exists
  const position = first?.position || { x: 50, y: 50, scale: 100 };
  
  const photoStyle = isPrinting ? {
  // PDF-safe styles
  position: 'absolute',
  width: '100%',
  height: 'auto',
  minWidth: '100%',
  minHeight: '100%',
  top: '50%',
  left: '50%',
  transform: `translate(-50%, -50%) scale(${position.scale / 100}) translateX(${position.x - 50}%) translateY(${position.y - 50}%)`,
} : {
  // LIVE PREVIEW styles (reverted to object-fit)
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  objectPosition: `${position.x}% ${position.y}%`,
  transform: `scale(${position.scale / 100})`,
  transformOrigin: `${position.x}% ${position.y}%`,
};

  return (
    <div style={{
      position:'absolute', inset:0, display:'grid',
      gridTemplateColumns:'2fr 1fr', gap:12, padding:18, background:'#fff'
    }}>
      <div 
        style={{ 
          border:'1px dashed #ddd', 
          borderRadius:6, 
          padding:12, 
          fontSize:14, 
          color:'#444',
          fontFamily: 'Georgia, serif',
          lineHeight: '1.6'
        }}
        dangerouslySetInnerHTML={{
          __html: sanitizeRichText(meta?.text || (showText ? 'Your story goes here…' : ''))
        }}
      />
      <div style={{ background:'#f3f4f6', borderRadius:8, overflow:'hidden', position: 'relative' }}>
        {first?.url ? (
          <PrintSafeImage 
  src={first.url} 
  alt="" 
  style={photoStyle} 
  position={position} 
  isPrinting={isPrinting} 
/>
        ) : null}
      </div>
    </div>
  );
}